import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import AuthCard from "@/components/AuthCard";
import { apiError } from "@/lib/errors";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setResult(data);
    } catch (err) {
      toast.error(apiError(err));
    } finally { setLoading(false); }
  };

  return (
    <AuthCard overline="Account Recovery" title="FORGOT PASSWORD" testid="forgot-password-page">
      {result ? (
        <div className="space-y-4" data-testid="forgot-password-result">
          <p className="text-sm text-slate-700">{result.message}</p>
          {result.reset_link && (
            <div className="border-l-4 border-[#FACC15] bg-yellow-50/60 p-3 space-y-2">
              <p className="font-overline text-[10px] text-slate-600">Email delivery not configured — use this link</p>
              <a href={result.reset_link} className="text-xs break-all text-[#0A1128] underline" data-testid="reset-link">
                {result.reset_link}
              </a>
            </div>
          )}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <p className="text-sm text-slate-600">Enter your account email and we'll generate a password reset link (valid for 1 hour).</p>
          <div>
            <Label htmlFor="fp-email">Email</Label>
            <Input id="fp-email" type="email" required value={email} onChange={e => setEmail(e.target.value)}
              className="rounded-sm" data-testid="forgot-email"/>
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#0A1128] hover:bg-slate-800 rounded-sm font-heading h-11" data-testid="forgot-submit">
            {loading ? "Sending..." : "SEND RESET LINK"}
          </Button>
        </form>
      )}
      <Link to="/login" className="block mt-6 text-sm text-slate-600 hover:text-[#0A1128]" data-testid="back-to-login">← Back to sign in</Link>
    </AuthCard>
  );
}
